import { Component } from '@angular/core';
import { LogotypeComponent } from 'apps/couriers-portal/src/app/core/components/logotype/logotype.component';

@Component({
  selector: 'peca-stand-by',
  templateUrl: './stand-by.component.html',
  styleUrl: './stand-by.component.scss',
  imports: [LogotypeComponent],
})
export class StandByComponent {}
